export default __webpack_public_path__ + "static/onetwotrip-8d111cc413b3d423727a27942ab09de8.png";